import { render, staticRenderFns } from "./DiscussChooseItem.vue?vue&type=template&id=3cad76e0&"
import script from "./DiscussChooseItem.vue?vue&type=script&lang=js&"
export * from "./DiscussChooseItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports